// MediConsult GmbH / Dr. Hoffmann-Prinzip color tokens.
export const colorTokens = {
  darkBlue: "#1a4c2c",
  darkBlueDeep: "#141f6c",
  blue: "#0042b6",
  blueLight: "#3a6cd6",
  blueSoft: "#e5ecff",
  white: "#ffffff",
  greyLight: "#f4f5f9",
  grey: "#a5a5a5",
  greyMid: "#6b6e7d",
  greyDark: "#3a3d4a",
  ink: "#0e1330",
  warningRed: "#e23b3b",
  success: "#16a34a",
};

export const themeSettings = (mode = "light") => ({
  palette: {
    mode,
    primary: {
      main: colorTokens.darkBlue,
      light: colorTokens.blueLight,
      dark: colorTokens.darkBlueDeep,
      contrastText: colorTokens.white,
    },
    secondary: {
      main: colorTokens.blue,
      contrastText: colorTokens.white,
    },
    background: {
      default: colorTokens.white,
      alt: colorTokens.greyLight,
      paper: colorTokens.white,
    },
    text: {
      primary: colorTokens.ink,
      secondary: colorTokens.greyMid,
    },
    custom: { ...colorTokens },
    error: { main: colorTokens.warningRed },
  },
  typography: {
    fontFamily: ['Bicyclette', 'Arial', 'sans-serif'].join(","),
    fontSize: 14,
    h1: { fontFamily: 'Athelas, "Athelas Regular", Georgia, serif', fontWeight: 400, letterSpacing: "-0.02em" },
    h2: { fontFamily: 'Athelas, "Athelas Regular", Georgia, serif', fontWeight: 400, letterSpacing: "-0.015em" },
    h3: { fontFamily: 'Athelas, "Athelas Regular", Georgia, serif', fontWeight: 400 },
    h4: { fontFamily: 'Athelas, "Athelas Regular", Georgia, serif', fontWeight: 400 },
    h5: { fontFamily: 'Athelas, "Athelas Regular", Georgia, serif', fontWeight: 400 },
    h6: { fontFamily: 'Athelas, "Athelas Regular", Georgia, serif', fontWeight: 400 },
    button: { textTransform: "none", letterSpacing: "0.02em", fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: colorTokens.white,
          color: colorTokens.ink,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, borderRadius: 999 },
      },
    },
    MuiModal: { defaultProps: { disableScrollLock: true } },
    MuiDialog: { defaultProps: { disableScrollLock: true } },
    MuiPopover: { defaultProps: { disableScrollLock: true } },
    MuiMenu: { defaultProps: { disableScrollLock: true } },
  },
});
